// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT: ``,
    ACCOUNT_PROFILE: `Perfil de cuenta`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    VERIFY_LINK_INVALID: ``,
    VERIFY_LINK_INVALID_LOG_IN: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADD_CARD: ``,
    CARD_NICKNAME: ``,
    NO_SAVED_CARDS: ``,
    QR_CODE: ``,
    REFRESH_QR_CODE: ``,
    QR_CODE_SCAN_TO_PAY: ``,
    ADA_TOGGLE_ON: `Toca para activar la altura de pantalla reducida`,
    ADA_TOGGLE_OFF: `Toca para desactivar la altura de pantalla reducida`,
    ADD: `Agregar`,
    ADD_DONATION: `Agregar donación`,
    ADD_FUNDS: `Agregar fondos`,
    ADD_TIP: `Agregar propina`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Agregar al pedido`,
    ADD_NEW: `Agregar nuevo`,
    ADDED: `Agregado`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Agregado al pedido`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Escriba su elección.`,
    ADDRESS_CITY: `Ciudad`,
    ADDRESS_LINE_1: `Dirección`,
    ADDRESS_LINE_2: `Dpto, Piso, Suite, Edificio, Empresa (Opcional)`,
    ADDRESS_POSTAL_CODE: `Código postal`,
    ALCOHOL_VERIFICATION: `Verificación de alcohol`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `También te puede interesar`,
    APPLIED_STORED_VALUE_CARDS: `Tarjetas de regalo`,
    ASAP: `Lo antes posible`,
    AT_LEAST_X: `al menos {{$1: number}}`,
    BACK: `Atrás`,
    BACK_TO_MENU: `Volver al menú`,
    BACK_TO_MENU_FROM_LOYALTY: `Volver al menú`,
    BACK_TO_CART: `Volver al carrito`,
    BACK_TO_PAYMENT_OPTIONS: `Volver a opciones de pago`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Volver a opciones de pago`,
    BAD_ACCESS_CODE: `Código de acceso incorrecto`,
    BALANCE: `Saldo`,
    BAG_OPT_IN_PROMPT: `¿Desea agregar una bolsa para llevar a su pedido?`,
    BAG_OPT_IN_TITLE: `¿Agregar una bolsa?`,
    BAG_OPT_IN: `Sí, quiero una bolsa`,
    BAG_OPT_OUT: `No, gracias`,
    BLOCKED_WORD_WARNING: `Por favor, elimine las palabras bloqueadas`,
    CALORIES: `Calorías`,
    CANCEL: `Cancelar`,
    CANCEL_CHECKOUT: `Cancelar`,
    CASH: `Cajero`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Tarjeta registrada`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Contactless`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Ingresado manualmente`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Proporcionada externamente`,
    CARD_ENTRY_SCAN: `Escanear`,
    CARD_ENTRY_SWIPE: `Deslizar`,
    CARD_ENTRY_UNKNOWN: `Desconocido`,
    CARD_EXPIRED: `Tarjeta vencida`,
    CARD_EXPIRING: `Su tarjeta vence pronto`,
    CARD_ENDING_IN: ``,
    CARD_EXPIRES_ON: ``,
    CARD_EXPIRES_THIS_MONTH: ``,
    CARD_EXPIRED_LABEL: ``,
    REMOVE_SAVED_CARD_DESCRIPTION: ``,
    CARD_RENAMED: ``,
    REMOVE_SAVED_CARD: ``,
    REMOVE_SAVED_CARD_TITLE: ``,
    RENAME_CARD: ``,
    SHOW_QR_CODE: ``,
    CART: `Carrito`,
    CART_LABEL: `Ir al carrito con {{$1: number}} artículos por {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Cambiar artículo`,
    CHANGE_PASSWORD: `Cambiar contraseña`,
    CHANGE_PASSWORD_SUCCESS: `Su contraseña ha sido actualizada.`,
    CHARS_LEFT: `{{$1: number}} caracteres restantes`,
    CHECK_AMOUNT: `Verificando monto...`,
    CHECKOUT: `Pagar`,
    CHECKOUT_STEP_CART: `Carrito`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Pago`,
    CHECKOUT_STEP_PAYING: `Pagando`,
    CHECKOUT_STEP_DONE: `Listo`,
    CHECKOUT_WITH_FORCED_MENU: `No puede pagar con la Vista previa del menú. El pago solo está disponible en el menú "Mostrado actualmente".`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `Elija una opción`,
    CHOOSE_TIME_SLOT: `Por favor, elija un horario:`,
    CLEAR_ALL: `Limpiar todo`,
    CLEARING_SESSION: `Preparando el quiosco para el siguiente cliente...`,
    CLOSE: `Cerrar`,
    CLOSED_SCREEN_MESSAGE: `Lo sentimos estamos cerrados o no aceptamos pedidos móviles.`,
    CONFIRM: `Confirmar`,
    CONFIRM_ADDRESS: `Confirmar dirección`,
    CONFIRM_DISCARD: `¿Descartar artículo?`,
    CONFIRM_DISCARD_CHANGES: `¿Estás seguro de que quieres descartar tus cambios?`,
    CONFIRM_YOUR_ITEM: `Confirme su artículo`,
    CONFIRM_QUIT: `¿Está seguro de que desea salir?`,
    CONFIRM_REFUND_AMOUNT: `¿Está seguro de que desea reembolsar {{$1: dollar amount}} de esta transacción?`,
    CONFIRMING_YOUR_CARD: `Confirmando su tarjeta...`,
    CONTINUE: `Continuar`,
    CONTINUE_AS_GUEST: `Continuar como invitado`,
    COULD_WE_INTEREST: `Quizás te interese...`,
    COMP_CARD: `Tarjeta de cortesía`,
    COMP_CARD_SCAN: `Escanear tarjeta de cortesía`,
    COMP_CARD_SCAN_FAILED_TITLE: `Error al escanear tarjeta de cortesía`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Hubo un error al escanear la tarjeta de cortesía. Por favor, intente de nuevo.`,
    COMP_CARD_APPLYING_TITLE: `Aplicando tarjeta de cortesía`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Error al aplicar tarjeta de cortesía`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Hubo un error al aplicar la tarjeta de cortesía. Por favor, intente de nuevo.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Por favor ingrese el número de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Por favor ingrese un número válido de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Por favor ingrese un número válido de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Por favor ingrese el PIN de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Por favor ingrese un PIN válido de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Por favor ingrese un PIN válido de la tarjeta de cortesía`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Ingrese el número de la tarjeta de cortesía. Los números pueden tener {{$1: number}} dígitos.`,
    COMP_CARD_ENTERING_PIN_HINT: `Ingrese el PIN de la tarjeta de cortesía. Los números pueden tener {{$1: length}} dígitos.`,
    COMP_CARD_ERROR_REMOVING: `Hubo un error al eliminar la tarjeta de cortesía. Por favor, intente de nuevo.`,
    'bottom-bar.storm-toggle.on': `Toca para activar la navegación Storm`,
    'bottom-bar.storm-toggle.off': `Toca para desactivar la navegación Storm`,
    'campus-card.label': `Tarjeta del campus`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Toca para pagar con tarjeta universitaria`,
    'campus-card.scan': `Escanee su tarjeta universitaria`,
    'campus-card.scan-failed.title': `Error al escanear tarjeta universitaria`,
    'campus-card.scan-failed.message': `Hubo un error al escanear la tarjeta universitaria. Por favor, intente de nuevo.`,
    'campus-card.enter-number': `Ingrese su número de tarjeta universitaria`,
    'campus-card.enter-pin': `Ingrese su PIN de tarjeta universitaria`,
    'campus-card.applying.title': `Aplicando tarjeta universitaria`,
    'campus-card.applying.error.title': `Error al aplicar tarjeta universitaria`,
    'campus-card.applying.error.message': `Hubo un error al aplicar la tarjeta universitaria. Por favor, intente de nuevo.`,
    'campus-card.entering-number.error.required': `Por favor, ingrese un número de tarjeta universitaria.`,
    'campus-card.entering-number.error.invalid': `Por favor, ingrese un número de tarjeta universitaria válido.`,
    'campus-card.entering-number.error.length': `Por favor, ingrese un número de tarjeta universitaria válido.`,
    'campus-card.entering-number.hint': `Ingrese su número de tarjeta universitaria. Los números pueden tener {{$1: number}} dígitos.`,
    'campus-card.entering-pin.error.required': `Por favor, ingrese el PIN de la tarjeta universitaria`,
    'campus-card.entering-pin.error.invalid': `Por favor, ingrese un PIN válido de la tarjeta universitaria`,
    'campus-card.entering-pin.error.length': `Por favor, ingrese un PIN válido de la tarjeta universitaria`,
    'campus-card.entering-pin.hint': `Ingrese el PIN de su tarjeta universitaria. Los números pueden tener {{$1: length}} dígitos.`,
    'campus-card.error-removing': `Hubo un error al eliminar la tarjeta universitaria. Por favor, intente de nuevo.`,
    'campus-card.no-balance.title': `Sin saldo disponible`,
    'campus-card.no-balance.message': `No hay saldo disponible en esta tarjeta universitaria.`,
    'campus-card.add-another': `Agregar otro`,
    'campus-card.remove': `Eliminar tarjeta universitaria`,
    'campus-card.select-account.title': `Seleccione una cuenta`,
    'campus-card.select-account.loading': `Cargando cuentas...`,
    'campus-card.select-account.error.title': `No se pueden cargar las cuentas`,
    'campus-card.select-account.error.message': `No pudimos cargar sus cuentas. Por favor, intente de nuevo.`,
    'campus-card.select-account.column.account': `Cuenta`,
    'campus-card.select-account.column.balance': `Saldo actual`,
    'campus-card.select-account.error.toast-title': `Error`,
    'campus-card.select-account.error.toast-message': `Error al validar. Por favor, intente de nuevo.`,
    'campus-card.swipe': `Deslice su tarjeta universitaria para pagar`,
    COUPON: `Cupón`,
    COUPON_ALREADY_USED: `El código de cupón ya fue utilizado.`,
    COUPON_MIN_SPEND_NOT_MET: `El código de cupón ingresado no cumple con el requisito de compra mínima.`,
    COUPON_NOT_FOUND: `Código de cupón no encontrado.`,
    COUPON_NOT_ACCEPTED: `El código de cupón ingresado no fue aceptado.`,
    COUPON_APPLYING: `Aplicando cupón`,
    COUPON_APPLYING_ERROR_TITLE: `Error al aplicar cupón`,
    COUPON_APPLYING_ERROR_MESSAGE: `Hubo un error al aplicar el cupón. Por favor, intente de nuevo.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `El código de cupón ingresado no cumple con los requisitos del pedido.`,
    COUPON_SCANNING_ERROR_TITLE: `Error al escanear cupón`,
    COUPON_SCANNING_ERROR_MESSAGE: `Hubo un error al escanear el cupón. Por favor, intente de nuevo.`,
    COUPON_ENTERING_ERROR_LENGTH: `Por favor, ingrese un código de cupón.`,
    COUPON_ENTERING_ERROR_INVALID: `Por favor, ingrese un código de cupón válido.`,
    COUPON_ERROR_REMOVING: `Hubo un error al eliminar el cupón. Por favor, intente de nuevo. Si el problema persiste, contacte al personal.`,
    CREATE_A_NEW_ACCOUNT: `Crear cuenta nueva`,
    CREATE_ACCOUNT: `Crear cuenta`,
    CREATE_ACCOUNT_TERMS_LINE: `Al crear una cuenta usted acepta los`,
    CREDIT_CARD: `Tarjeta de crédito`,
    CREDIT_CARD_NUMBER: `Número de tarjeta`,
    CURBSIDE: `En la acera`,
    CURRENT_PASSWORD: `Contraseña actual`,
    CUSTOM_TIP: `Personalizada`,
    CUSTOM_TIP_INVALID: `Por favor, ingrese un monto de propina válido.`,
    CUSTOM_TIP_HINT: `Ingrese el monto de su propina. Máximo: {{$1: number}}`,
    CUSTOM_DONATION: `Donación personalizada`,
    CUSTOMER_CARDS: `Usar una tarjeta guardada`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Iniciar sesión`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Su cuenta`,
    CUSTOMIZE: `Personalizar`,
    DEBIT: `Débito`,
    DEBIT_CREDIT_CARD: `Tarjeta débito/crédito`,
    DEMO_PAY: `Demo: Pagar`,
    DELIVERY: `Entrega a domicilio`,
    DELIVERY_ADDRESS: `Dirección de entrega`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `Eliminar {{$1: mod name}}`,
    DINE_IN: `Para comer aquí`,
    DISCLAIMER_EMAIL: `El uso del correo electrónico está sujeto a los Términos de servicio.`,
    DISCLAIMER_PHONE: `El uso del número de teléfono está sujeto a los Términos de servicio.`,
    DISCLAIMER_PHONE_LINK: `TÉRMINOS DE SERVICIO:`,
    DISCLAIMER_PHONE_DESCRIPTION: `PARA USO DEL NÚMERO DE TELÉFONO`,
    DISCLAIMER_NAME: `Su nombre se utilizará para confirmar y facilitar el retiro de su pedido en el área designada.`,
    DISCOUNTS: `Descuentos`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Los descuentos se aplicarán al pagar`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `El descuento se aplicará al pagar`,
    DONATION: `Donación`,
    DONATION_APPLYING: `Aplicando donación...`,
    DONATION_APPLY_ERROR_TITLE: `Error al aplicar donación`,
    DONATION_APPLY_ERROR_MESSAGE: `Hubo un error al aplicar su donación. Por favor, intente de nuevo.`,
    DONATION_FAILED: `La donación falló. Por favor, intente de nuevo.`,
    DONATION_ROUND_UP_TITLE: `¿Desea redondear su total?`,
    DONATION_ROUND_UP_TO: `Redondear a {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `¿Desea redondear su total al dólar completo más cercano?`,
    DONATION_ROUND_UP_ACCEPT: `Sí redondear`,
    DONATION_ROUND_UP_REJECT: `No, gracias`,
    DONATION_REMOVE: `Eliminar donación`,
    DONE: `Listo`,
    DONT_INCLUDE_UTENSILS: `No incluir cubiertos`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `Reembolso EBT`,
    EBT_CHOICE_DIALOG_TITLE: `¿Qué método EBT desea usar?`,
    EBT_CHOICE_CASH_BENEFIT: `Beneficio en efectivo`,
    EBT_CHOICE_FOOD_STAMPS: `Estampillas de comida`,
    EBT_CARD_SUBTITLE: `Deslice su tarjeta EBT en la terminal de tarjetas`,
    EDIT: `Editar`,
    EDIT_ORDER: `Editar pedido`,
    EDIT_TIP: `Editar propina`,
    SAVE_ORDER: `Guardar pedido`,
    SAVE_BUTTON: ``,
    EMAIL_ADDRESS: `Correo electrónico`,
    EMAIL_RECEIPT: `Recibo por correo electrónico`,
    EMAIL_REQUIRED_FOR_RECEIPT: `Se requiere un correo electrónico para su recibo.`,
    EMAIL_RECEIPT_SEND_FAILED: `No se pudo enviar el recibo. Por favor, intente de nuevo.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Recibo enviado exitosamente.`,
    ENTER_ACCESS_CODE: `Ingrese el código de acceso:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `Ingrese su correo electrónico`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `¿No puede escanear? Ingrese el número de su tarjeta.`,
    ENTER_PHONE_CONSENT: `Doy mi consentimiento para recibir materiales de marketing por SMS.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Ingrese su número de teléfono`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Hola {{$1 guest name}} por favor, ingrese su número de teléfono`,
    ENTER_PHONE_LOYALTY: `Ingrese su número de teléfono móvil`,
    ENTER_PHONE_RECEIPT: `Ingrese su número de teléfono móvil para recibir un recibo`,
    ENTER_PHONE_TEXT_WHEN_READY: `¡Ingrese su número de teléfono para recibir un mensaje de texto cuando su pedido esté listo!`,
    ENTER_VEHICLE_DESCRIPTION: `Por favor, ingrese los detalles de su vehículo para que podamos llevarle su pedido:`,
    ENTER_YOUR_COUPON_CODE: `Ingrese su código de cupón`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Ingrese su número de tarjeta de cortesía`,
    ENTER_YOUR_COMP_CARD_PIN: `Ingrese su PIN de tarjeta de cortesía`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Ingrese su número de tarjeta de regalo`,
    ENTER_YOUR_GIFT_CARD_PIN: `Ingrese su PIN de tarjeta de regalo`,
    ENTER_YOUR_EMAIL: `Ingrese su correo electrónico:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `Correo electrónico inválido. Por favor, intente de nuevo.`,
    ENTER_YOUR_FIRST_NAME: `Ingrese su nombre:`,
    ENTER_YOUR_LAST_NAME: `Ingrese la inicial de su apellido:`,
    ENTER_YOUR_NAME: `Ingrese su nombre:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Nombre inválido. Por favor, intente de nuevo.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `Por favor, ingrese un nombre.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `Solo se permite una letra. Por favor, intente de nuevo.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `El nombre debe contener solo letras. Por favor, intente de nuevo.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `El nombre contiene palabras inapropiadas. Por favor, intente de nuevo.`,
    ERROR: `¡Ups!`,
    ERROR_ADDING_ITEM: `Hubo un error al agregar el artículo a su carrito. Por favor intente de nuevo. Si el problema persiste pida ayuda al miembro del equipo más cercano.`,
    ERROR_EDITING_ITEM: `Hubo un error al editar el artículo en su carrito. Por favor intente de nuevo. Si el problema persiste pida ayuda al miembro del equipo más cercano.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `El monto supera el saldo de la tarjeta.`,
    ERROR_CARD_CONFIRMATION: `¡Lo sentimos! No se pudo confirmar la tarjeta. Por favor intente de nuevo.`,
    ERROR_CARD_DECLINED: `No se pudo realizar el cargo a la tarjeta indicada. Por favor, inténtelo de nuevo.`,
    ERROR_CARD_INACTIVE: `Lo sentimos esta tarjeta de estudiante no está activa.`,
    ERROR_CARD_NOT_FOUND: `¡Lo sentimos! No pudimos encontrar esta tarjeta. Por favor, intente de nuevo.`,
    ERROR_CARD_NUMBER_LENGTH: `El número de tarjeta no tiene la longitud correcta.`,
    ERROR_CARD_RESTRICTED_TIME: `Lo sentimos esta tarjeta no se puede usar en este momento.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Lo sentimos, {{$1: cardScheme}} no se acepta aquí. ¿Podría intentar con otra tarjeta?`,
    ERROR_COUPON_CONFIRMATION: `¡Lo sentimos! No se pudo usar el código de cupón. Por favor, intente de nuevo.`,
    ERROR_INVALID_EMAIL: `Correo electrónico inválido`,
    ERROR_INVALID_LOGIN_CREDS: `Usuario o contraseña inválidos`,
    ERROR_INVALID_NAME: `Por favor, ingrese un nombre válido`,
    ERROR_INVALID_PHONE_NUMBER: `Por favor, ingrese un número de teléfono válido`,
    ERROR_INVALID_ROOM_NUMBER: `Por favor, ingrese un número de habitación válido`,
    ERROR_INVALID_TABLE_NUMBER: `Por favor, ingrese un número de mesa válido`,
    ERROR_INVALID_VERIFICATION_CODE: `Código de verificación inválido`,
    ERROR_KIOSK_CARD_DECLINED: `Algo salió mal. Su tarjeta no fue cobrada. Por favor, intente de nuevo.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `No se pudo leer la tarjeta. Inténtelo de nuevo.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `El quiosco no pudo encontrar el dispositivo de pago. Su tarjeta no fue cobrada. Por favor, comuníquese con un miembro del personal.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `El dispositivo de pago parece estar desconectado. Su tarjeta no fue cobrada. Por favor, comuníquese con un miembro del personal.`,
    ERROR_ORDER_OPERATION: `Lo sentimos no pudimos procesar su pedido. Por favor, intente de nuevo.`,
    ERROR_PIN_LENGTH: `El PIN no tiene la longitud correcta.`,
    ERROR_RECEIVING_PAYMENT: `La terminal no pudo procesar su pago. Por favor, intente de nuevo.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `No se recibió ningún pago. Este pedido no ha sido enviado. Su recibo contendrá un resumen de su pedido. Por favor, comuníquese con un miembro del personal para obtener más ayuda.`,
    ERROR_SENDING_ORDER: `Hola, parece haber un problema al enviar su pedido a la cocina. Por favor comuníquese con un miembro del personal para obtener ayuda.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `El pago fue exitoso pero hubo un problema al enviar su pedido a la cocina. Por favor, comuníquese con un miembro del personal. Su recibo contendrá un resumen de su pedido.`,
    ERROR_STARTING_ORDER: `Lo sentimos no pudimos iniciar su pedido. Por favor, intente de nuevo. Si el problema persiste comuníquese con un miembro del personal.`,
    ERROR_UPDATING_ORDER: `Lo sentimos no pudimos actualizar su pedido. Por favor, intente de nuevo. Si el problema persiste comuníquese con un miembro del personal.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `No se puede ver este artículo. Ha alcanzado el límite de alcohol para este pedido. Por favor, elimine una bebida alcohólica para agregar esta.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `No se puede ver este artículo. Ha alcanzado el límite de oferta especial para este pedido. Por favor, elimine un artículo de oferta especial para agregar este.`,
    EXIT: `Salir`,
    EXIT_CONFIRMATION: `¿Está seguro de que desea salir? Al salir se cancelará su pedido.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Favorito`,
    FAVORITES: `Favoritos`,
    FAVORITES_NONE_YET: `Aún no hay favoritos.`,
    FAVORITES_REMOVE_CONFIRMATION: `¿Está seguro de que desea eliminar este favorito?`,
    FETCHING_RECOMMENDATIONS: `Obteniendo recomendaciones...`,
    FIND_ACCOUNT: `Buscar cuenta`,
    FIRST_NAME: `Nombre`,
    FORGOT_PASSWORD: `¿Olvidó su contraseña?`,
    FULFILLMENT_LABEL_ADDRESS: `Dirección`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `Correo electrónico`,
    FULFILLMENT_LABEL_GUEST_NAME: `Para`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Número de pedido`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Número de mesa`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Número de teléfono`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Número de rastreador`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Descripción del vehículo`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Su pedido será entregado en la dirección indicada.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Le enviaremos el recibo.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Su nombre será llamado cuando su pedido esté listo.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Se llamará su número de pedido.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Recibirá un mensaje de texto cuando su pedido esté listo.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Su pedido será servido en su mesa.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Su rastreador sonará cuando el pedido esté listo.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Su pedido será entregado una vez que haya llegado afuera del restaurante.`,
    FULFILLMENT_TOGGLE: `Cambiar método de entrega activo`,
    FULL_NAME: `Nombre completo`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `¡Lo sentimos! No se pudo encontrar el menú para ese horario. Por favor, intente de nuevo.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `¡Lo sentimos! No se encontraron horarios disponibles. Por favor, intente con otra opción de comedor.`,
    FUTURE_ORDER_SET_FOR: `Pedido programado para:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `¡Lo sentimos! El horario elegido ya no está disponible. Por favor seleccione un horario diferente.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Algo salió mal al buscar los horarios disponibles. Por favor intente de nuevo. Si el problema persiste comuníquese con un miembro del personal.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `Por favor, seleccione un horario.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Horarios disponibles`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Hoy`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Mañana`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Retiro hoy a las {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Retiro el siguiente día hábil a las {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Tiempo estimado de preparación del pedido: {{$1: time}}`,
    GENERIC_ERROR: `¡Vaya! Algo salió mal. Por favor, intente de nuevo. Si el problema persiste comuníquese con un miembro del personal.`,
    GET_REWARDS: `Obtener recompensas`,
    GET_RECEIPT: `Obtener recibo`,
    GET_RECEIPT_DIALOG_TITLE: `Opciones de recibo`,
    GIFT_CARD: `Tarjeta de regalo`,
    GIFT_CARD_SECONDARY: `Tarjeta de regalo alternativa`,
    GIFT_CARD_TITLE: `Pagar ahora`,
    GIFT_CARD_SUBTITLE: `Pague deslizando su tarjeta de regalo en el lector de tarjetas.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Error al escanear tarjeta de regalo`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `No pudimos escanear su tarjeta de regalo. Por favor intente de nuevo.`,
    GIFT_CARD_APPLYING_TITLE: `Aplicando tarjeta de regalo`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Error al aplicar tarjeta de regalo`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `No pudimos aplicar su tarjeta de regalo. Por favor intente de nuevo.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Saldo insuficiente en tarjeta de regalo`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `Su tarjeta de regalo no tiene saldo.`,
    GIFT_CARD_ADD_ANOTHER: `Agregar otra`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Por favor, ingrese un número de tarjeta de regalo.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `Por favor, ingrese un número de tarjeta de regalo válido.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Por favor, ingrese un número de tarjeta de regalo válido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `Por favor, ingrese un PIN.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `Por favor, ingrese un PIN válido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `Por favor, ingrese un PIN válido.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Ingrese el número de tarjeta de regalo. Los números pueden tener {{$1: length}} dígitos.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Ingrese el PIN. Los números pueden tener {{$1: length}} dígitos.`,
    GIFT_CARD_ERROR_REMOVING: `Error al eliminar la tarjeta de regalo. Por favor, intente de nuevo. Si el problema persiste comuníquese con un miembro del personal.`,
    'gift-card.select-account.title': `Seleccione una cuenta`,
    'gift-card.select-account.loading': `Cargando cuentas...`,
    'gift-card.select-account.error.title': `No se pueden cargar las cuentas`,
    'gift-card.select-account.error.message': `No pudimos cargar sus cuentas. Por favor, intente de nuevo.`,
    'gift-card.select-account.column.account': `Cuenta`,
    'gift-card.select-account.column.balance': `Saldo actual`,
    'gift-card.select-account.error.toast-title': `Error`,
    'gift-card.select-account.error.toast-message': `Error al validar. Por favor, intente de nuevo.`,
    GLOSSARY_TERM_LEARN_MORE: `Más información`,
    GOES_WELL_WITH: `Combina bien con`,
    GRAND_TOTAL: `Total general`,
    GROUP_ORDERING_ADD_GUEST: `Agregar invitado`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `El nombre del invitado contiene caracteres inválidos.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `El nombre del invitado ya está en uso. Por favor, ingrese un nombre diferente.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Invitado {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Pedido grupal - ¿Para quién es este artículo?`,
    GROUP_ORDERING_LABEL: `Pedido grupal - Artículo para:`,
    GROUP_ORDERING_TITLE: `Pedido grupal`,
    GROUP_ORDERING_SUBTITLE: `La opción de pedido grupal le preguntará a qué miembro de su grupo corresponde cada artículo. Toque Sí para activar el pedido grupal. Toque No si desea continuar.`,
    GUEST_INFO: `Información del cliente`,
    GUEST_RATING_LABEL_0: `Toque para calificar como 0: Muy insatisfecho`,
    GUEST_RATING_LABEL_1: `Toque para calificar como 1: Un poco insatisfecho`,
    GUEST_RATING_LABEL_2: `Toque para puntuar como 2: Un poco satisfecho`,
    GUEST_RATING_LABEL_3: `Toque para puntuar como 3: Muy satisfecho`,
    GUEST_RATING_0: `¡Gracias por sus comentarios!`,
    GUEST_RATING_1: `¡Gracias por sus comentarios!`,
    GUEST_RATING_2: `¡Gracias por sus comentarios!`,
    GUEST_RATING_3: `¡Gracias por sus comentarios!`,
    GUEST_RATING_SUBMITTED: `¡Gracias por sus comentarios!`,
    HIDE: `Ocultar`,
    HOME: `Inicio`,
    HOW_DID_WE_DO: `¿Cómo lo hicimos? ¡Califícanos!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `¿Cómo desea pagar?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `¿Cómo desea su pedido?`,
    KITCHEN_CLOSED: `Lo sentimos la cocina está cerrada.`,
    ID_CHECK_LABEL: `Su pedido contiene alcohol. Es posible que se le pida mostrar una identificación.`,
    ID_CHECK_CODE_MESSAGE: `Se requiere un código de acceso de empleado para pagar con alcohol. Por favor, solicite ayuda a un miembro del equipo.`,
    IE_WARNING: `Hemos observado que está accediendo a nuestro sitio desde Internet Explorer. Para obtener una mejor experiencia, ábralo con navegadores compatibles como Google Chrome, Safari, Firefox o Microsoft Edge.`,
    INCLUDE_UTENSILS: `Incluir cubiertos`,
    ITEM_86D: `Hola, parece haber un problema al enviar su pedido a la cocina porque un artículo está agotado. Por favor, comuníquese con un miembro del personal para obtener ayuda.`,
    ITEM_86D_VALIDATION: `Hola, parece que hay un problema para enviar su pedido a la cocina debido a que un artículo está agotado. Por favor, solicite ayuda a un miembro del personal.`,
    ITEM_RECIPIENT: `Hecho para`,
    ITEM_RECIPIENT_FOR: `Hecho para {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Recomendado`,
    ITEM_STEP_TITLE: `Paso {{$1: step}}`,
    ITEM_STEP_EMPTY: `No se realizaron elecciones en este paso`,
    ITEM_STEP_NO_RECOS: `No hay recomendaciones disponibles`,
    ITEMS_NO_LONGER_IN_MENU: `Algunos artículos han sido eliminados de su carrito porque ya no están en el menú`,
    ITEM_SCAN_ERROR: `No pudimos encontrar este artículo. Por favor, agréguelo desde el menú o pida ayuda a un miembro del personal.`,
    ITEM_SCAN_SUCCESS: `¡Artículo agregado al carrito!`,
    LAST_NAME: `Apellido`,
    LEAD_TIME_LONG: `Su pedido puede necesitar más tiempo del horario seleccionado actualmente.`,
    LEAD_TIME_CART: `Este pedido puede tardar más en prepararse que la hora de recogida solicitada debido a algunos artículos seleccionados.`,
    LANGUAGE_SELECT_LABEL: `Toque para seleccionar idioma`,
    LOADING: `Cargando...`,
    LOADING_MENU: `Cargando el menú...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Buscar tiendas`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Buscar una tienda para {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `¿Cómo desea ordenar?`,
    LOCATION_SEARCH_HEADER: `Bienvenido a {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Dirección, ciudad y estado, o código postal`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Iniciar sesión`,
    LOGIN: `Iniciar sesión`,
    LOGIN_GIFT_CARD: `Inicio de sesión con tarjeta de regalo`,
    LOGIN_GIFT_CARD_SECONDARY: `Inicio de sesión con tarjeta de regalo alternativa`,
    LOGIN_WALL_WELCOME: `¡Hola!`,
    LOGIN_WALL_WELCOME_USER: `¡Hola {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `Iniciar sesión con número de tarjeta`,
    LOGIN_WITH_PHONE: `Iniciar sesión con teléfono`,
    LOOKING_UP_ACCOUNT: `Buscando cuenta...`,
    LOOKUP_CARD: `Buscando tarjeta...`,
    LOOKUP_COUPON: `Buscando cupón...`,
    LOYALTY: `Programa de fidelidad`,
    LOYALTY_ACCOUNT_APPLY: `Aplicar`,
    LOYALTY_CARD_NUMBER: `Número de tarjeta`,
    LOYALTY_EXIT_TO_MENU: `Ir al menú`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `Escanear código QR de la app`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `¿Sin app? Ingrese su número de teléfono.`,
    LOYALTY_AUTH_METHOD_BARCODE: `Escanear código QR de la app`,
    LOYALTY_AUTH_METHOD_HID: `Tocar tarjeta HID`,
    LOYALTY_AUTH_METHOD_PHONE: `Ingrese su número de teléfono.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Ingrese su número de tarjeta.`,
    LOYALTY_AUTH_METHOD_EMAIL: `Ingrese su correo electrónico.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Ingrese su correo electrónico y contraseña.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Ingrese su correo electrónico y número de teléfono.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Ingrese su nombre de usuario y contraseña.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Ingrese el número de teléfono de su cuenta:`,
    LOYALTY_APP_AUTH_SUBTITLE: `Para encontrar el código de barras abra su App en la pantalla PAGAR.`,
    LOYALTY_APP_AUTH_TITLE: `Escanee el código de barras de pago de su App con el escáner de abajo.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `Ingresa manualmente el código de recompensa de 7 dígitos`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `Ingresa un código de recompensa de 7 dígitos:`,
    LOYALTY_APPLY_REWARD_FAILED: `No se pudo aplicar la recompensa. Por favor, intente de nuevo.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `No se pudieron aplicar las siguientes recompensas: {{$1: reward names}}. Por favor, intente de nuevo.`,
    LOYALTY_APPLYING_REWARD: `Aplicando recompensa...`,
    LOYALTY_AUTH_GENERIC_ERROR: `¡Lo sentimos! No pudimos encontrar esta cuenta de recompensas. Por favor, intente de nuevo.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Inicie sesión para ganar y usar los puntos de su programa de recompensas.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Recompensas disponibles`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Saldo actual`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Lo sentimos, no puede modificar sus recompensas una vez que ha pagado el pedido.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Lo sentimos esta recompensa no se puede eliminar una vez aplicada al pedido.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Ingrese su número de tarjeta para ganar y usar los puntos de su programa de recompensas.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Lo sentimos, no puede usar sus recompensas porque hay un cupón aplicado.`,
    LOYALTY_GETTING_REWARDS: `Obteniendo sus recompensas...`,
    LOYALTY_FETCH_REWARDS_FAILED: `No se pudieron obtener las recompensas. Por favor, intente de nuevo.`,
    LOYALTY_REWARD_APPLY: `Aplicar`,
    LOYALTY_REWARD_APPLY_FAILED: `No se pudieron aplicar las recompensas. Es posible que algunas no apliquen a su pedido.`,
    LOYALTY_REWARD_APPLIED: `Aplicado`,
    LOYALTY_REWARD_INVALID: `Inválido`,
    LOYALTY_REWARD_LABEL_MEAL: `Comida`,
    LOYALTY_REWARD_LABEL_MEALS: `Comidas`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Canjear ahora`,
    LOYALTY_REWARD_LABEL_SELECTED: `Seleccionado`,
    LOYALTY_REWARD_LABEL_APPLIED: `Canjeado`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Canjeado al pagar`,
    LOYALTY_REWARD_LABEL_REMOVING: `Eliminando`,
    LOYALTY_REWARD_LABEL_ERROR: `Error al aplicar`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `No aplicable`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Recompensas`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Recompensas por porcentaje`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Recompensas fijas`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Recompensas de billetera`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Recompensas de billetera y pago`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Recompensas de artículo gratis`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Recompensas de intercambio de comida`,
    LOYALTY_REWARDS_FOR: `Para`,
    LOYALTY_NO_REWARDS_LABEL: `Sin recompensas`,
    LOYALTY_NO_REWARDS_NO_EARNING: `No hay recompensas aplicables para estos artículos.`,
    LOYALTY_NO_REWARDS_TEXT: `No hay recompensas aplicables para estos artículos, pero ¡igual ganará puntos con este pedido!`,
    LOYALTY_PAYMENT: `Con programa de fidelidad`,
    LOYALTY_PAYMENT_CARD_CHARGED: `Se cobrará {{$1: charge_amount}} a la tarjeta registrada.`,
    LOYALTY_PAYMENT_FAILED: `No se pudo aplicar el pago.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Hubo un problema al procesar el pago de lealtad. Por favor, intente de nuevo o elija otro método de pago.`,
    USE_LOYALTY_PAYMENT: `Usar programa de fidelidad`,
    LOYALTY_PAYMENT_SUBMIT: `Realizar pago`,
    LOYALTY_PAYMENT_REWARD: `Cargado al programa de fidelidad`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `Su tarjeta registrada con el proveedor será cobrada por esta transacción.`,
    LOYALTY_PAY_WITH_APP: `Pagar con la app`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Puntos de recompensa estimados para este pedido:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }} puntos`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Estado de cuenta`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `No pudimos encontrar su cuenta.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Por favor, inicie sesión en su cuenta a continuación para ganar puntos y canjear recompensas.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `Registrarse con número de teléfono`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `¡Aún puede ganar puntos en su pedido de hoy escaneando el recibo después de registrarse!`,
    LOYALTY_INTRO_QR_SIGN_IN: `Por favor, escanee su código QR a continuación para iniciar sesión.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Por favor, escanee el código QR a continuación para registrarse.`,
    LOYALTY_INTRO_WELCOME_BACK: `Bienvenido`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `El número de teléfono proporcionado está asociado a más de una cuenta de fidelidad o no existe.`,
    LOYALTY_REDEMPTION_CODE: `Aplicar código de canje`,
    LOYALTY_REMOVING_REWARD: `Eliminando recompensa...`,
    LOYALTY_SCAN_FAILED_TITLE: `Error al escanear`,
    LOYALTY_SCAN_FAILED_MESSAGE: `No pudimos escanear su código QR. Por favor intente de nuevo.`,
    LOYALTY_SIGN_OUT_NOTICE: `Se cerrará sesión automáticamente cuando se realice su pedido o salga del menú.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `Se cerrará sesión automáticamente cuando se realice su pedido o salga del menú. Las contraseñas nunca se guardan.`,
    LOYALTY_SIGN_UP_SMS_SENT: `¡Se envió el mensaje de registro!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Volver al inicio de sesión`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `¡Registro exitoso!`,
    LOYALTY_SIGN_UP_WITH_QR: `Registrarse con código QR`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `Registrarse con número de teléfono`,
    LOYALTY_WELCOME_TITLE: `Gane y use recompensas`,
    LOYALTY_SIGNUP_TITLE: `Reciba un enlace de registro en su teléfono`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Actualmente tiene`,
    LOYALTY_NAV_REWARDS: `Mis recompensas`,
    LOYALTY_NAV_ORDER_HISTORY: `Mis pedidos`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Ha superado el número máximo de intentos de inicio de sesión.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Ha superado el número máximo de intentos de acceso a la tarjeta de regalo.`,
    MAKE_IT_A_COMBO: `¿Hacer combo?`,
    MAKE_IT_A_COMBO_MOD: `¿Agregarlo como combo?`,
    MAKE_IT_A_COMBO_ACCEPT: `¡Sí, por favor!`,
    MAKE_IT_A_COMBO_REJECT: `¡No, gracias!`,
    MAKE_IT_A_COMBO_NO: `No, gracias, sin combo.`,
    MAKE_IT_A_COMBO_YES: `¿Hacer combo?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `¡Excelente elección!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `¡Elija su acompañamiento y bebida abajo!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `¡Agregue un acompañamiento y una bebida para hacer un combo!`,
    MENU_COVER_ALT_TEXT: `Toque aquí para comenzar a ordenar`,
    MENU_COVER_LOYALTY_TEXT: `Inicie sesión en fidelidad para ganar puntos y canjear recompensas.`,
    MENU_COVER_QUIZ_TEXT: `¡Completa el cuestionario para descubrir qué artículo es ideal para ti!`,
    MENU_COVER_WAYFINDER_TEXT: `Vaya a nuestro buscador de rutas para orientarse`,
    MAINTENANCE_COVER_TITLE: `Este quiosco está en mantenimiento`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el HID esté conectado al quiosco.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID desconectado`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el KDS esté conectado al quiosco.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS desconectado`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Por favor, intente con otro quiosco o pida ayuda a un miembro del personal.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Este quiosco no está disponible actualmente`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el lector de banda magnética esté conectado al quiosco.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Lector de banda magnética desconectado`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el quiosco esté conectado a la red.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Sin conexión de red`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Este quiosco tiene problemas de conexión debido a una velocidad de internet baja. Por favor, verifique que su conexión sea estable. Velocidad recomendada: mínimo 10 Mbps de carga y descarga.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Red inestable detectada`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el dispositivo de pago esté encendido y conectado al quiosco.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Dispositivo de pago desconectado`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Por favor, asegúrese de que la cubierta de la impresora esté cerrada.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Cubierta de impresora abierta`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que la impresora esté conectada al quiosco.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Impresora desconectada`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Por favor, asegúrese de que la impresora tenga papel.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Impresora sin papel`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que la balanza esté conectada al quiosco.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Balanza desconectada`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Por favor, asegúrese de que el escáner esté conectado al quiosco.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Escáner desconectado`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `El límite máximo de bebidas alcohólicas por pedido es {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `El límite máximo de artículos especiales por pedido es {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `¿Cómo le gustaría ordenar?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Seleccione un idioma para comenzar`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Toque aquí para iniciar el pedido y ver este artículo promocionado: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Toque aquí para iniciar el pedido e ir directamente a esta sección promocionada: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Toque aquí para iniciar el pedido e ir directamente a esta página promocionada: ¡{{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `¡Toque aquí para iniciar el pedido para {{$1: fulfillment method}}!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Volver a opciones de comedor`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Volver al número de teléfono`,
    MARKETING_CONSENT: `Quiero recibir noticias actualizaciones descuentos y ofertas`,
    MENU_FILTERS_DIETARY_FILTERS: `Opciones dietéticas`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Para una opción más saludable, seleccione una de estas opciones para que sólo se muestren en el menú.`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Preferencias nutricionales`,
    MENU_FILTERS_OTHER_FILTERS: `Otros`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Restrictivo`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Si tiene ciertas intolerancias, seleccione una de ellas para ocultarlas del menú`,
    MENU_FILTERS_COUNT: `{{$1: number}} Preferencias de nutrición activas. Toque para editar.`,
    MOD_86D: `Hola, parece que hay un problema al enviar su pedido a la cocina debido a que un artículo está agotado. Por favor, póngase en contacto con un miembro del personal para obtener ayuda. Tenga en cuenta que su pago FUE aceptado por el restaurante.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} artículos en total`,
    MOD_GROUP_CHOICES_INCREMENT: `Múltiples de {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `Realice una única elección`,
    MOD_GROUP_CHOICES_MAKE_X: `Realice {{$1: number range, e.g. 2-3}} elecciones diferentes`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} por elección`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Elija al menos {{$1: number}}`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Elija entre {{$1: number}} y {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `Elija uno`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Elija hasta uno`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Elija hasta {{$1: number}}`,
    MOD_GROUP_CHOOSE_X: `Elija {{$1: number}}`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Mostrar - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Ocultar - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `{{$1: dollar amount}} para gastar antes de ser cobrado.`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `Opciones adicionales a {{$1: dollar amount}} por opción.`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `Los primeros {{$1: number}} son gratis.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `El primero es gratis.`,
    MOD_GROUP_WALLET_UP_TO_X: `Hasta {{$1: number}} a {{$2: dollar amount}} por elección`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Cerrar sustitución`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Cambiar sustitución`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Sustituir`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Agregar al artículo`,
    MOD_RECOMMENDED_BADGE: `Recomendado`,
    MOD_UPSELL_PROMPT_TITLE: `¿Agregar opción?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Agregar`,
    MOD_UPSELL_PROMPT_DECLINE: `No, gracias`,
    MODIFY: `Modificar`,
    MODIFY_INGREDIENTS: `Modificar ingredientes`,
    MORE: `más`,
    NAME_CALLED_ORDER_READY: `Su nombre será llamado cuando su pedido esté listo.`,
    NAME_ON_CARD: `Nombre en la tarjeta`,
    NEED_MORE_TIME: `¿Necesita más tiempo?`,
    NEW_PASSWORD: `Nueva contraseña`,
    NEXT: `Siguiente`,
    NO: `No`,
    NO_ITEMS_MATCH_FILTERS: `Ningún artículo coincide con sus filtros.`,
    NO_ORDERS_MATCH: `Ningún pedido coincide con su búsqueda.`,
    NO_THANKS: `No, gracias`,
    NO_TIP: `Sin propina`,
    NOT_A_MEMBER: `¿No es miembro?`,
    NUTRITION_INFO_CALORIES: `Calorías`,
    NUTRITION_INFO_PROTEIN: `Proteínas`,
    NUTRITION_INFO_FAT: `Grasas`,
    NUTRITION_INFO_CARBS: `Carbohidratos`,
    NUTRITION_INFO_SUGAR: `Azúcares`,
    OK: `Aceptar`,
    OR: `o`,
    OPT_OUT_OF_RECOMMENDATIONS: `No recibir recomendaciones`,
    ORDER_GET_ERROR: `Lo sentimos tuvimos problemas al crear su pedido. Por favor, intente de nuevo.`,
    ORDER_HISTORY: `Historial de pedidos`,
    ORDER_HISTORY_EMPTY: `No hay pedidos en su historial. Una vez que realice un pedido, aparecerá aquí.`,
    ORDER_HISTORY_ERROR: `Lo sentimos tuvimos problemas al cargar su historial de pedidos. Por favor, intente de nuevo.`,
    ORDER_SENT: `Pedido enviado`,
    ORDER_SUMMARY: `Resumen del pedido`,
    ORDER_SUMMARY_WITH_NAME: `Resumen del pedido de {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Resumen del pedido {{$1 fulfillment}} Pedido`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Resumen del pedido {{$1 fulfillment}} Pedido para {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Resumen del pedido {{$1 fulfillment}} Pedido para la mesa {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Resumen del pedido{{$1 fulfillment}} Pedido para el dispositivo de seguimiento #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Resumen del Pedido {{$1 fulfillment}}  Pedido para {{$2 guest name}} en la Mesa {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Resumen del Pedido {{$1 fulfillment}}  Pedido para {{$2 guest name}} dispositivo de seguimiento {{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Resumen del Pedido. {{$1 fulfillment}} Pedido para la Orden #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Resumen del Pedido. {{$1 fulfillment}}Pedido para el dispositivo de seguimiento #{{$2: tracker number}} para el Pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Resumen del Pedido {{$1 fulfillment}} Pedido para la Mesa {{$2: table number}} para el Pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Resumen del Pedido. {{$1 fulfillment}} Pedido para {{$2 guest name}} para el Pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Resumen del Pedido {{$1 fulfillment}} Pedido Para {{$2 guest name}} en la Mesa {{$3: table number}} para el Pedido #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Resumen del Pedido {{$1 fulfillment}} Pedido Para {{$2 guest name}} en el dispositivo de seguimiento {{$3: tracker number}} Para el Pedido  #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `¡Lo sentimos! El restaurante está recibiendo más pedidos de los que puede atender. Por favor, intente con un horario diferente.`,
    ORDER_TIME_ASAP: `Hacer un pedido lo antes posible`,
    ORDER_TIME_LATER: `Más tarde hoy`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Siguiente día hábil`,
    ORDER_TIME_FUTURE: `Pedir para después`,
    ORDER_TOTAL_MAX_EXCEEDED: `Para pedidos grandes, por favor, consulte con un miembro del personal.`,
    ORDER_UPDATE_FAILED: `No se pudo actualizar el pedido.`,
    ORDER_VALIDATION_IN_PROGRESS: `Validando su pedido`,
    ORDER_VALIDATION_FAILED: `¡Vaya! Algo salió mal.`,
    ORDER_WAS_PLACED: `Su pedido fue realizado.`,
    ORDERING_MODE_CHANGED: `Modo de pedido cambiado. Su sesión ha sido reiniciada.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Toque aquí para convertir {{$1: ordered item name}} en un combo.`,
    ORDERED_ITEM_COMBO_LABEL: `Combo`,
    ORDERING_ITEM_ABSENCE_RESET: `Este artículo estaba desactualizado. El artículo se ha restablecido a su estado inicial. Por favor, intente de nuevo.`,
    OUR_MENU: `Nuestro menú`,
    OUTPOST_PICKUP: `Recogida en punto de entrega`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Ingrese el número de su habitación de punto de entrega`,
    OUTPOST_ROOM_NUMBER_TITLE: `Número de habitación`,
    OUT_OF_STOCK: `Agotado`,
    PAGE_NAVIGATION_TITLE: `Toque una de las opciones a continuación para ir a una página específica del menú. {{$1: total}} páginas disponibles.`,
    PAGE_NOT_FOUND: ``,
    PAGE_NOT_FOUND_MESSAGE: ``,
    PAGE_ERROR: ``,
    PAGE_ERROR_MESSAGE: ``,
    GO_TO_HOME_PAGE: ``,
    PARTIAL_PAYMENT_LINE: `Pago Parcial`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Pago parcial`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `Hay un pago parcial en este pedido. Si desea regresar su pago será reembolsado primero.`,
    PASSWORD: `Contraseña`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `Hola, si no completa el pago en los próximos 5 minutos cancelaremos el pedido y reembolsaremos su pago.`,
    PAY_AT_CASHIER: `Por favor, diríjase al cajero para pagar.`,
    PAY_NOW: `Pagar ahora`,
    PAY_WITH: `Pagar con`,
    PAY_WITH_CREDIT: `Pagar con tarjeta de crédito`,
    PAY_WITH_DEBIT_CREDIT: `Pagar con débito/crédito`,
    PAYMENT: `Pago`,
    PAYMENT_DETAILS: `Detalles del pago`,
    PAYMENT_LINE_LABEL_DONATION: `Donación por {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `El subtotal es {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Pago parcial para {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Canje de tarjeta regalo de  {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Cupón de descuento de {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Cupón de descuento de {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `Pago con EBT por {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Canje de recompensas de {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Canje de recompensa de {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Descuento de  {{$1: name}} por {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `El impuesto es {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `La propina es {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `El cargo de servicio es {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `El cargo de servicio es {{$1: amount}} para {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `El total general es  {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `El saldo restante es  {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `El importe pagado es  {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Toque para pagar con Efectivo`,
    PAYMENT_OPTION_LABEL_CARD: `Toque para pagar con una Tarjeta de Crédito`,
    PAYMENT_OPTION_LABEL_COUPON: `Toque para canjear un Cupón`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Toque para canjear una Tarjeta Compuesta`,
    PAYMENT_OPTION_LABEL_DONATION: `Toque para hacer o editar donaciones`,
    PAYMENT_OPTION_LABEL_EBT: `Toque para pagar con EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Toque para reembolsar EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Toque para pagar con beneficio en efectivo de EBT`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Toque para pagar con cupones de alimentos de EBT`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Toque para pagar con una Tarjeta de Regalo`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Toque para canjear recompensas`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Toque para canjear recompensas`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Toque para completar el pago`,
    PAYMENT_PROMPT_NFC: `Pague en el lector de tarjetas insertando su tarjeta o acercando su teléfono móvil.`,
    PAYMENT_PROMPT_DIP: `Pague en el lector de tarjetas insertando su tarjeta.`,
    PAYMENT_SUCCESSFUL: `Pago exitoso`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Lo sentimos su pago falló. Por favor, intente de nuevo.`,
    PAYMENT_KIOSK_TIMEOUT: `Lo sentimos la sesión de pago expiró. Por favor, intente de nuevo.`,
    PAYMENT_TOTAL: `Total del pago`,
    PAYMENT_WAS_TAKEN: `Tenga en cuenta que su pago fue procesado.`,
    PAYMENT_WAS_NOT_TAKEN: `Tenga en cuenta que su pago no fue procesado. Esto no es una confirmación de pago.`,
    PHONE_NUMBER: `Número de teléfono`,
    PICK_UP: `Recoger`,
    PICK_UP_AT: `Recoger en`,
    PICK_UP_ENTER_NUMBER: `Por favor, elige un número e ingrésalo abajo:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Hola {{$1: guest name}} por favor, elige un número e ingrésalo abajo:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Por favor tome un rastreador e ingrese su número:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Hola {{$1: guest name}} por favor, tome un rastreador e ingrese su número:`,
    PLACE_ORDER: `Realizar pedido`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Por favor, ingrese un monto válido para reembolsar.`,
    PLEASE_USE_TEST_CARD: `Esta ubicación todavía está en modo de prueba. Por favor, use una tarjeta de prueba para pagar.`,
    PLEASE_WAIT: `Espere, por favor...`,
    PRICE: `El precio es {{$1:price}}`,
    PRINTING_RECEIPT: `Imprimiendo su recibo...`,
    PRINT_RECEIPT: `Imprimir recibo`,
    PRINT_RECEIPT_ERROR: `Lo sentimos hubo un error al imprimir su recibo. Por favor intente de nuevo más tarde.`,
    PRINTED_RECEIPT_COMMAND: `¡Por favor, recuerde llevar su recibo!`,
    PROCESSING_PAYMENT: `Procesando pago...`,
    PROMOTED_MODIFIER: `¡Promoción activada!`,
    QUANTITY_SELECT: `¡{{$1:quantity}} Ascendido!`,
    QUANTITY_SELECT_INCREASE: `Seleccionada`,
    QUANTITY_SELECT_DECREASE: `Aumentar Cantidad`,
    QUANTITY_SELECT_LABEL: `Disminuir Cantidad`,
    QUIT: `Salir`,
    QUICK_CHECKOUT: `Pago rápido`,
    QUICK_NAV_TAP_TO_VIEW: `Toque para ver`,
    QUIZ_RESULTS_TITLE: `Resultados`,
    QUIZ_RESULTS_EMPTY: `No se encontraron resultados. Intente de nuevo con otras respuestas.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Toque para ver el siguiente resultado. {{$1:index}} de {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Toque para ver el resultado anterior. {{$1:index}} de {{$2:total}}`,
    QUIZ_STEP_ERROR: `Por favor, responda todas las preguntas antes de continuar.`,
    QUIZ_STEP_ANSWER_LABEL: `Toque para responder con {{$1:badge name}}:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Escanee el código QR para obtener una copia de su recibo en su teléfono.`,
    RECEIPT_AUTHORIZATION: `Autorización`,
    RECEIPT_CARD_NUMBER: `Tarjeta#`,
    RECEIPT_CHECK_ID: `COMPROBAR DOCUMENTO DE IDENTIDAD`,
    RECEIPT_DISCOUNTS: `Descuentos`,
    RECEIPT_DONATION: `Donación`,
    RECEIPT_FAILED: `Hola, parece que hay un problema al enviar su pedido a la cocina. Por favor, contacte a un miembro del personal para obtener ayuda.`,
    RECEIPT_FAILED_ITEM_86D: `Hola, parece que hay un problema para enviar su pedido a la cocina debido a que un artículo está agotado. Por favor, solicite ayuda a un miembro del personal.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `Los siguientes artículos no se incluyeron en el Código QR porque no tienen un PLU asociado a ellos:`,
    RECEIPT_NOT_RECEIPT: `Esto no es un recibo ni comprobante de compra.`,
    RECEIPT_ORDER: `PEDIDO`,
    RECEIPT_ORDER_TOTAL: `Total del pedido`,
    RECEIPT_PAY_AT_CASHIER: `POR FAVOR PAGUE EN EL CAJERO`,
    RECEIPT_PICK_UP_AT_LABEL: `Recoger en`,
    RECEIPT_PICKUP_TIME_LABEL: `Hora de recogida`,
    RECEIPT_DELIVERY_TIME_LABEL: `Hora de entrega`,
    RECEIPT_PRINTED: `Recibo impreso`,
    RECEIPT_REFUNDED: `Reembolsado`,
    RECEIPT_REMAINING_BALANCE: `Saldo restante`,
    RECEIPT_SELF_SERVE: `Autoservicio:`,
    RECEIPT_SPECIAL_REQUEST: `Solicitud especial`,
    RECEIPT_SUB_TOTAL: `Subtotal`,
    RECEIPT_TAX_TOTAL: `Total de impuestos`,
    RECEIPT_TIP_THANKS: `Propina (¡Gracias!)`,
    RECEIPT_SERVICE_CHARGE: `Cargo por servicio`,
    RECEIPT_TRANS_NO: `Nº DE TRANSAC. QUIOSCO`,
    RECEIPT_YOUR_CHECK_NUMBER: `Su número de cheque es`,
    RECOMMENDATIONS: `Recomendaciones`,
    RECOMMENDED_FOR_YOU: `Recomendado para usted`,
    REFUND: `Reembolso`,
    REFUNDER_ALREADY_REFUNDED: `Reembolsado`,
    REFUNDER_DELAY_MESSAGE: `Los reembolsos pueden tardar algunos días en aparecer en su estado de cuenta.`,
    REFUNDER_INSTRUCTIONS: `Para buscar pedidos, use el número de Autorización en el recibo, el número de pedido, la dirección de correo electrónico, el número de teléfono, los cuatro últimos dígitos de la tarjeta, el número de referencia de transacción o la ID de pedido.`,
    REFUNDER_SEARCH_PLACEHOLDER: `Número de autorización del recibo, número de pedido o últimos cuatro dígitos de la tarjeta`,
    REFUNDER_TITLE: `Reembolsar un pedido`,
    REFUNDER_SEARCHING_TITLE: `Buscando`,
    REFUNDER_RESULTS_TITLE: `Pedidos`,
    REFUNDER_RESULTS_EMPTY: `No se encontraron pedidos. Por favor, verifique sus criterios de búsqueda e intente de nuevo.`,
    REFUNDER_REFUNDING_TITLE: `Reembolsando`,
    REFUNDER_REFUND_ERROR: `Hubo un error al procesar su reembolso. Por favor, intente de nuevo. Si el problema persiste comuníquese con soporte.`,
    REFUNDER_REFUND_SUCCESS: `¡Reembolso exitoso! La transacción será procesada en breve.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Busque de nuevo`,
    REFUNDER_SEARCH_INPUT_ERROR: `Por favor, ingrese un número de autorización, número de pedido o los últimos cuatro dígitos de la tarjeta válidos.`,
    REFUNDER_SEARCH_ERROR: `Se ha producido un error al buscar su pedido. Por favor, inténtelo de nuevo. Si el problema persiste, contacte con el servicio de asistencia.`,
    REFUNDING: `Procesando reembolso...`,
    REFUND_FAILED: `El reembolso falló. Por favor, intente de nuevo más tarde.`,
    REMOVE: `Eliminar`,
    REMOVE_CARD: `No olvide retirar su tarjeta.`,
    REMOVE_COMP_CARD: `Eliminar tarjeta de cortesía`,
    REMOVE_COUPON: `Eliminar cupón`,
    REMOVE_GIFT_CARD: `Eliminar`,
    REMOVE_TIP: `Eliminar propina`,
    REMOVING_COUPON: `Eliminando cupón...`,
    REORDER: ``,
    REPEAT_PASSWORD: `Repetir contraseña`,
    RESET: `Restablecer`,
    REWARDS: `Recompensas`,
    REWARDS_LOGGED_IN: `Recompensas`,
    REWARDS_APPLICABLE_TO_ORDER: `Aplicable ahora a su pedido`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Aún no aplicable a su pedido`,
    REWARDS_EDIT: `Editar Recompensas`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} puntos`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} comidas`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} puntos`,
    SAVE: `Actualizar`,
    SAVE_CARD: `Guardar tarjeta en la cuenta para futuras compras.`,
    SCAN_COUPON_BELOW: `Puede escanear cupones con el escáner de abajo.`,
    SCAN_YOUR_GIFT_CARD: `Escanee su tarjeta de regalo`,
    SEARCH: `Buscar`,
    SEARCH_BEGIN: `Ingrese su término de búsqueda a continuación para comenzar a buscar.`,
    SEARCH_EMPTY: `No se encontraron resultados. Intente con un término de búsqueda diferente.`,
    SEARCH_HINT: `Busque artículos usando cualquier combinación de nombre o descripción.`,
    SECRET_MENU_IMAGE_ALT: `Toque para ver el Menú secreto`,
    SELECT_DATE: `Seleccionar fecha`,
    SELF_SERVE: `Autoservicio`,
    SEND: `Enviar`,
    SEND_LOYALTY_SMS: `Enviar SMS`,
    SEND_ORDER_UI_TIMEOUT: `Hola, seguimos intentando enviar su pedido a la cocina. Por favor, solicite ayuda a un miembro del personal.`,
    SENT_LOYALTY_SIGNUP_SMS: `Se envió el SMS. Revise su teléfono y regístrese cuando sea posible.`,
    SENDING_ORDER_KITCHEN: `Enviando pedido a la cocina...`,
    SENDING_ORDER_VALIDATION: `Confirmando el pedido...`,
    SENDING_RECEIPT: `Enviando recibo...`,
    SENDING_SMS: `Enviando SMS...`,
    SERVICE_CHARGE: `Cargo por servicio`,
    SHOW: `Mostrar`,
    SHOW_NUTRITION: `Mostrar información nutricional`,
    SHOW_STAFF_FIRST: `Por favor, muestre este mensaje a un miembro del personal antes de salir.\n¿Seguro que desea salir?`,
    SIGNUP_CTA: `¡Regístrese para obtener una cuenta!`,
    SIGN_OUT: `Cerrar sesión`,
    SIGN_UP: `Registrarse`,
    SIGNUP_BENEFITS: `Cree una cuenta para guardar su tarjeta de crédito y artículos favoritos para un pago más fácil.`,
    SIGNUP_LOYALTY: `Registrarse en lealtad`,
    SKIP: `Omitir`,
    SPECIAL_REQUESTS: `Solicitudes especiales`,
    SPECIAL_REQUESTS_EXAMPLE: `ej: salsa aparte, sin anchoas, etc.`,
    SPECIAL_REQUESTS_FINEPRINT: `Las sustituciones y solicitudes pueden generar un cargo adicional.`,
    SPECIAL_REQUESTS_ADD: `Agregar solicitud especial`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `La solicitud especial es demasiado larga.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Por favor use solo letras, números y puntuación.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Por favor ingrese una solicitud especial.`,
    SR_REMOVE_ITEM_FROM_CART: `Eliminar artículo del carrito.`,
    STARTING_ORDER: `Iniciando pedido...`,
    UPDATING_ORDER: `Actualizando pedido...`,
    START_ORDER_BY_SCANNING: `Comience su pedido escaneando un artículo en la parte inferior del kiosco.`,
    START_NEW_ORDER: `Iniciar otro pedido`,
    STORED_VALUE_REMAINING_BALANCE: `restantes`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Información de la tienda`,
    STUDENT_CARD: `Tarjeta de estudiante`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Lo sentimos esta tarjeta de estudiante no tiene fondos.`,
    STUDENT_CARD_SUBTITLE_HID: `Toque su tarjeta de estudiante para pagar`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Toque o deslice su tarjeta de estudiante para pagar`,
    STUDENT_CARD_SUBTITLE_MSR: `Deslice su tarjeta de estudiante para pagar`,
    SUBMIT: `Enviar`,
    SUBTOTAL: `Subtotal`,
    SUBTOTAL_REDUCED: `Subtotal reducido`,
    SUBTOTAL_INCREASED: `Nuevo subtotal`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `¡Está ahorrando con un combo!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Usted ahorra`,
    SUCCESS: `Exitoso`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Cambiar ubicación`,
    SWITCH_TO_CATERING: `Cambiar a servicio de catering`,
    SWITCH_TO_WEB: `Cambiar a pedidos en línea`,
    SWIPE_YOUR_GIFT_CARD: `Deslice su tarjeta de regalo para pagar`,
    SWIPE_YOUR_COMP_CARD: `Deslice su tarjeta de cortesía para pagar`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Deslice o escanee su tarjeta de regalo para pagar`,
    TAKING_LONGER_THAN_USUAL: `Tardando más de lo habitual...`,
    TAP_HERE_FOR_LANGUAGE: `Toque aquí para {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Toque fuera para cerrar`,
    TAP_TO_REDEEM: `Toque para canjear`,
    TAXES: `Impuesto`,
    TERMS_OF_SERVICE: `Términos de servicio`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Error al cargar los Términos de servicio`,
    TEXT_RECEIPT: `Recibo por mensaje de texto`,
    TEXT_RECEIPT_SEND_FAILED: `No se pudo enviar el recibo por mensaje de texto.`,
    TEXT_RECEIPT_SEND_SUCCESS: `¡Recibo enviado!`,
    TEXT_YOU_WHEN_READY: `Le enviaremos un mensaje de texto cuando su pedido esté listo.`,
    THANK_YOU: `¡Gracias!`,
    THEN_PRESS_BUTTON_1: `Luego, presione el`,
    THEN_PRESS_BUTTON_2: `botón.`,
    TIP: `Propina`,
    TIPPING: `Incluyendo propina...`,
    TIP_AMOUNT_TOO_HIGH: `El monto de la propina es demasiado alto.`,
    TIP_AMOUNT_TOO_LOW: `El monto de la propina es demasiado bajo.`,
    TIP_FAILED: `¡Lo sentimos! No se pudo agregar una propina. Por favor. intente de nuevo.`,
    TIP_CANNOT_BE_MODIFIED: `¡Lo sentimos! No puede modificar su propina una vez que ha pagado el pedido.`,
    TIP_LABEL_PERCENT: `Toque para agregar un {{$1: percent}}% ({{$2: amount}})  de propina`,
    TIP_LABEL_FIXED: `Toque para agregar un  {{$1: amount}} de propina`,
    TIP_LABEL_CUSTOM: `Toque para agregar una propina personalizada`,
    TIP_LABEL_NONE: `Toque para eliminar la propina`,
    TO_GO: `Para llevar`,
    TOTAL: `Total`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `Los precios de algunos artículos de su pedido han cambiado.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `El subtotal ha cambiado y ahora es`,
    TOTAL_CHANGED_LEADING_TEXT: `El total ha cambiado y ahora es`,
    TOTAL_CHANGED_TRAILING_TEXT: `. ¿Desea continuar con el pedido?`,
    TOTAL_PAID: `Total pagado`,
    TOTAL_REMAINING: `Total restante`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Intentar de nuevo`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Parece que no hemos podido encontrar tu dirección. Por favor, ingrese su dirección.`,
    UNAVAILABLE_ITEM: `Lo sentimos este artículo ya no está disponible.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} Calorías`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} Proteína`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} Carbohidratos`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} Grasa`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} de azúcar`,
    UP_TO_X: `hasta {{$1: number}}`,
    USE_COMP_CARD: `Usar tarjeta de cortesía`,
    USE_COUPON: `Usar cupón`,
    USE_EBT_CARD: `Tarjeta EBT`,
    USE_EBT_CASH_BENEFIT: `Beneficio en efectivo EBT`,
    USE_EBT_FOOD_STAMP: `Estampillas de comida EBT`,
    USE_GIFT_CARD: `Usar tarjeta de regalo`,
    USERNAME: `Nombre de usuario`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `El correo electrónico no es válido`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `Se requiere {{$1: field name, e.g. 'email'}}`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Este campo es requerido`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Por favor use sólo letras y números`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Por favor use únicamente letras, números, &, # o .`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `La contraseña debe contener al menos 1 dígito, 1 letra mayúscula, 1 letra minúscula y tener al menos 14 caracteres.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `El número de teléfono no es válido`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `El código postal debe ser numérico`,
    VENDOR_UNAVAILABLE_MESSAGE: `Este vendedor está actualmente cerrado. Por favor, verifique los horarios de atención y regrese en otro momento.`,
    VEHICLE_COLOR: `Color del vehículo`,
    VEHICLE_MAKE: `Marca del vehículo`,
    VEHICLE_MODEL: `Modelo del vehículo`,
    VERIFY_ACCOUNT: `Verificar cuenta`,
    VERIFY_ACCOUNT_CTA: `Verifique su cuenta para comenzar a realizar pedidos.`,
    VIDEO_LOAD_FAILED: `Error al cargar el vídeo`,
    VIEW: `Ver`,
    WE_APOLOGIZE: `Nos disculpamos por cualquier inconveniente.`,
    WEIGHING_INSTRUCTIONS: `Coloque su artículo en la balanza.`,
    WELCOME_BACK: `¡Bienvenido de nuevo! Artículos seleccionados especialmente para usted:`,
    WELCOME_BACK_WITH_NAME: `¡Bienvenido de nuevo {{$1: guest name}}! Artículos seleccionados especialmente para usted:`,
    WELCOME_TO: `¡Bienvenido a {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Elegir horario del pedido`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `¿Dónde desea recibir su pedido?`,
    YES: `Sí`,
    YOU_PREVIOUSLY_ORDERED: `Anteriormente ordenó`,
    YOUR_CURRENT_LOCATION: `Su ubicación actual`,
    YOUR_NAME: `Su nombre`,
    YOUR_ORDER: `Su pedido`,
    YOUR_SUBTOTAL: `Su subtotal`,
    ZOOM_TOGGLE_ON: `Toca para activar el zoom con dos dedos`,
    ZOOM_TOGGLE_OFF: `Toca para desactivar el zoom con dos dedos`,
    ZOOM_INSTRUCTIONS: `El zoom con dos dedos está habilitado. Usa dos dedos para acercar y alejar.`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `Más información`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `¿Dónde estoy?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Estás Aquí`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Encontrar un lugar`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Arrastra con el dedo para explorar el espacio.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Toque un lugar destacado para obtener más información.`,
    'cover.session.timeout': `Algo salió mal. Por favor, intente de nuevo.`,
    'cover.reduced-height.button': `Comenzar a ordenar`,
    'cover.loyalty.title': `Bienvenido`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Iniciar sesión con Programa de Fidelidad`,
    'cover.loyalty.guest': `Continuar como invitado`,
    'guest-identifier.button.quit': `Salir`,
    'guest-identifier.button.skip': `Omitir`,
    'guest-identifier.button.back': `Atrás`,
    'guest-identifier.button.next': `Continuar`,
    'guest-identifier.button.submit.cover': `Continuar`,
    'guest-identifier.button.submit.edit': `Continuar`,
    'guest-identifier.button.submit.checkout': `Continuar`,
    'guest-identifier.phone.tos.button-back': `Atrás`,
    'guest-identifier.phone.tos.title': `Términos de servicio`,
    'guest-identifier.phone.tos.link': `Términos de servicio de número de teléfono`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Inicie sesión con su cuenta de fidelidad`,
    'guest-identifier.name.loyalty-button': `Iniciar sesión con fidelidad`,
    'guest-identifier.name.loyalty-separator': `o`,
    'guest-identifier.name.loyalty-error-title': `¡Vaya! No se encontró nombre`,
    'guest-identifier.name.loyalty-error-description': `Lo sentimos no pudimos encontrar un nombre asociado a la cuenta. Por favor, ingrese su nombre a continuació`,
    'inactivity-timer.button.continue': `Sí, necesito más tiempo`,
    'inactivity-timer.button.exit': `No, ya terminé`,
    'item-card.add.with-quantity': `Agregar ({{$1: quantity}})`,
    'image.scan.default.alt': `Escanee su código de barras o código QR`,
    'loyalty.view_coupons': `Ver cupones`,
    'loyalty.add_coupons': `Agregar cupones`,
    'loyalty.label.manual_redemption': `Código de canje`,
    'loyalty.label.manual_redemption_instructions': `Ingrese su código de canje para canjear su recompensa`,
    'loyalty.label.welcome.new-user': `¡Hola {{$1: user}}! Ya tiene una cuenta de fidelidad`,
    'loyalty.reward_label.payment_unapplied': `Aplicar pago a tarjeta registrada`,
    'loyalty.reward_label.redeemable_unredeemed': `Canjear usando {{$1: points}} puntos`,
    'loyalty.reward_label.payment_at_checkout': `El pago se puede aplicar al finalizar la compra.`,
    'loyalty.reward_group_label.payment': `Recompensas de pago`,
    'loyalty.rewards.payment-reward.name': `Pagar con saldo`,
    'loyalty.rewards.payment-reward.name-with-amount': `Pagar con saldo ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Su saldo actual`,
    'loyalty.rewards.card-on-file-payment.description': `El pago se cargará a su tarjeta registrada.`,
    'loyalty.redemption_auth.back_to_rewards': `Volver a recompensas`,
    'loyalty.redemption_auth.subtitle': `Escanee su código de barras de canje para canjear su recompensa`,
    'loyalty.redemption_auth.submit': `Canjear recompensa`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Ingrese su nombre`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Por favor, acepte los términos y condiciones para continuar.`,
    'loyalty.checkout-signup.header': `¡Última oportunidad para registrarse y ganar recompensas en este pedido!`,
    'loyalty.checkout-signup.skip': `Omitir y continuar al pago`,
    'loyalty.checkout-signup.success.new-account.title': `Nueva cuenta creada`,
    'loyalty.checkout-signup.success.new-account.description': `¡Gracias por unirse, ganará recompensas en este pedido!`,
    'loyalty.checkout-signup.success.existing-account.title': `La cuenta ya existe`,
    'loyalty.checkout-signup.success.existing-account.description': `Ya se ha registrado anteriormente con este número. Ahora ha iniciado sesión.`,
    'loyalty.checkout-signup.error.title': `Error al crear cuenta`,
    'loyalty.checkout-signup.error.description': `Algo salió mal durante la creación de la cuenta`,
    'loyalty.checkout-signup.error.skip': `Omitir y continuar al pago`,
    'loyalty.checkout-signup.error.try-again': `Intentar de nuevo`,
    'menu.item.reset': `Restablecer artículo`,
    'menu.mod-group.quick-select': `Selección rápida`,
    'menu.mod-group.quick-select-active': `Seleccionado`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Escanee artículos para comenzar a ordenar`,
    'menu.page.scanner.scanned.title': `Artículos del carrito`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Ver artículos escaneados`,
    'order-history.button.add-to-order': `Agregar artículos disponibles ({{$1: number}})`,
    'order-history.title': `Historial de pedidos`,
    'order-history.subtitle': `Todos sus pedidos anteriores aparecerán aquí. Interactúe con los artículos para verlos o agregarlos a su pedido actual. Puede agregar todos los artículos de un pedido con un solo toque.`,
    'order-history.next-page': `Siguiente`,
    'order-history.previous-page': `Anterior`,
    'order-history.screen.close': `Cerrar`,
    'order-history.screen.error.title': `Algo salió mal`,
    'order-history.screen.error.subtitle': `No se pudo cargar el historial de pedidos. Por favor, intente de nuevo más tarde.`,
    'order-history.screen.error.button.back': `Atrás`,
    'order-history.screen.error.button.retry': `Reintentar`,
    'order-history.screen.no-orders': `No se encontraron pedidos anteriores. Cuando realice un pedido vuelva aquí para verlo.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Algunos artículos de este pedido no están disponibles para reordenar rápidamente. Por favor, agregue los artículos tocándolos individualmente.`,
    'order-history.section.button.view-all': `Ver más de mis pedidos`,
    'order-history.topbar.button.back': `Atrás`,
    'loyalty.unapplicable_rewards_warning_title': `Recompensas no aplicables`,
    'loyalty.unapplicable_rewards_warning_description': `Para canjear la recompensa seleccionada, agregue los artículos correspondientes a su carrito. La recompensa y el descuento se aplicarán al pagar.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Aplicar`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Entrada manual`,
    'loyalty.button.menu.authed': `Recompensas`,
    'loyalty.button.menu.unauthed': `Recompensas`,
    'loyalty.button.checkout.authed': `Recompensas`,
    'loyalty.button.checkout.unauthed': `Recompensas`,
    'loyalty.error.reward_failed_to_apply': `No se pudo aplicar la recompensa. Por favor, intente de nuevo.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Omitir y continuar al menú`,
    'loyalty.login-options.button.skip.checkout': `Omitir y continuar al pago`,
    'loyalty.login-options.button.skip.dining-option-collection': `Omitir y continuar con el pago`,
    'loyalty.login-options.title': `Elija una opción para iniciar sesión o continuar como invitado`,
    'loyalty.login-options.subtitle': `Siempre puede iniciar sesión más tarde`,
    'loyalty.login-options.signup.link': `¿No tienes cuenta? Regístrate`,
    'loyalty.login-options.barcode.title': `Escanear código de barras`,
    'loyalty.login-options.barcode.subtitle': `Escanee su código de barras para iniciar sesión`,
    'loyalty.login-options.email-phone-number.title': `Correo electrónico y número de teléfono`,
    'loyalty.login-options.email-phone-number.subtitle': `Ingrese su correo electrónico y número de teléfono para iniciar sesión`,
    'loyalty.login-options.email-password.title': `Correo electrónico y contraseña`,
    'loyalty.login-options.email-password.subtitle': `Ingrese su correo electrónico y contraseña para iniciar sesión`,
    'loyalty.login-options.username-password.title': `Nombre de usuario y contraseña`,
    'loyalty.login-options.username-password.subtitle': `Ingrese su nombre de usuario y contraseña para iniciar sesión`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Número de teléfono`,
    'loyalty.login-options.phone-number.subtitle': `Ingrese su número de teléfono para iniciar sesión`,
    'loyalty.login-options.card-number.title': `Número de tarjeta`,
    'loyalty.login-options.card-number.subtitle': `Ingrese su número de tarjeta para iniciar sesión`,
    'loyalty.login-options.email.title': `Correo electrónico`,
    'loyalty.login-options.email.subtitle': `Ingrese su correo electrónico para iniciar sesión`,
    'loyalty.login-options.or': `O`,
    'loyalty.login-options.popup.close': `Cerrar`,
    'loyalty.error.or': `O`,
    'loyalty.login-error.saved-form': `La información que envió:`,
    'loyalty.login-error.try-again.button': `Intentar de nuevo`,
    'loyalty.otp.enter-code.title': `Ingrese el código que le enviamos`,
    'loyalty.otp.sent-to.email': `Enviamos un código por correo electrónico a {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `Enviamos un código por mensaje de texto a {{$1: masked phone number}}`,
    'loyalty.otp.verify': `Verificar`,
    'loyalty.otp.resend': `Reenviar código`,
    'loyalty.otp.code.error.invalid': `Ese código es incorrecto. Por favor, intente de nuevo.`,
    'loyalty.otp.send-error.message': `No pudimos encontrar una única cuenta con esa información. Por favor, verifíquela e intente de nuevo.`,
    'loyalty.login.fallback.phone-number.button': `Usar número de teléfono en su lugar`,
    'loyalty.login.fallback.barcode.button': `Escanear un código de barras o código QR en su lugar`,
    'loyalty.login.fallback.card-number.button': `Usar número de tarjeta en su lugar`,
    'loyalty.login.fallback.email.button': `Usar correo electrónico en su lugar`,
    'loyalty.login.fallback.email-phone-number.button': `Usar correo electrónico y número de teléfono en su lugar`,
    'loyalty.login.fallback.email-password.button': `Usar correo electrónico y contraseña en su lugar`,
    'loyalty.login.fallback.username-password.button': `Usar nombre de usuario y contraseña en su lugar`,
    'loyalty.login.auth-method.phone-number.title': `Número de teléfono`,
    'loyalty.login.auth-method.barcode.title': `Escanear código de barras o código QR`,
    'loyalty.login.auth-method.card-number.title': `Número de tarjeta`,
    'loyalty.login.auth-method.email.title': `Correo electrónico`,
    'loyalty.login.auth-method.email-phone-number.title': `Correo electrónico y número de teléfono`,
    'loyalty.login.auth-method.email-password.title': `Correo electrónico y contraseña`,
    'loyalty.login.auth-method.username-password.title': `Nombre de usuario y contraseña`,
    'vitrine.error.order_validation_failed': `No se pudo validar el pedido. Por favor, intente de nuevo.`,
    'vitrine.error.handshake_failed': `No se pudo conectar al quiosco. Por favor, comuníquese con un miembro del personal.`,
    'vitrine.error.request_timeout': `No se pudo completar la solicitud. Por favor, intente de nuevo.`,
    'vitrine.error.request_aborted': `No se pudo completar la solicitud. Por favor, intente de nuevo.`,
    'vitrine.error.analytics_send_error': `No se pudieron enviar los datos analíticos. Por favor, intente de nuevo.`,
    'vitrine.error.garcon_incompatible_build': `No se pudo conectar con el kiosco. Por favor, contacte a un miembro del personal para recibir ayuda.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `No se pudo encontrar su cuenta`,
    'vitrine.error.loyalty-login-no-matching-user-message': `No encontramos un usuario con la información proporcionada.`,
    'vitrine.error.loyalty_not_enough_points': `Su cuenta no tiene suficientes puntos para canjear las recompensas seleccionadas.`,
    'vitrine.error.order_total_above_max': `El total del pedido ha superado el máximo permitido. Por favor, comuníquese con un miembro del personal.`,
    'vitrine.error.empty_menu': `El menú que seleccionó está actualmente vacío. Por favor, intente con otra opción de pedido.`,
    'maitred.error.integration_bad_config': `Parece haber un problema con la configuración del quiosco. Por favor, comuníquese con un miembro del personal.`,
    'checkout.done.expo_receipt.error': `No se pudo imprimir el recibo. Por favor, intente de nuevo.`,
    'checkout.done.expo_receipt.success': `¡Recibo enviado! Por favor, pida ayuda a un miembro del equipo.`,
    'checkout.done.print-receipt.out-of-paper': `La impresora no tiene papel. Por favor, acuda a un miembro del personal para obtener su recibo.`,
    'refunder.viewing-results.button.cancel': `Cancelar`,
    'refunder.viewing-results.button.refund-all': `Reembolsar todo`,
    'refunder.viewing-results.button.view-transaction': `Ver transacciones`,
    'refunder.viewing-results.button.done': `Listo`,
    'refunder.viewing-results.button.back': `Atrás`,
    'refunder.viewing-results.button.search': `Buscar pedido`,
    'refunder.viewing-results.refund-order.error-print-receipt': `El pedido se reembolsó exitosamente, pero no pudimos imprimir el recibo. Por favor, intente imprimir de nuevo.`,
    'refunder.viewing-results.refund-order.success': `El pedido fue reembolsado exitosamente.`,
    'refunder.viewing-results.refund-order.error': `No se pudo reembolsar el pedido. Por favor, intente de nuevo.`,
    'refunder.viewing-results.order.refunded': `Pedido reembolsado`,
    'refunder.viewing-results.order.total': `Total del pedido`,
    'refunder.search-form.button.back': `Atrás`,
    'refunder.search-form.button.search': `Buscar`,
    'refunder.viewing-order.title': `Todas las transacciones del pedido #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Por favor, seleccione la transacción que desea reembolsar.`,
    'refunder.viewing-order.button.cancel': `Cancelar`,
    'refunder.viewing-order.button.refund': `Reembolsar`,
    'refunder.viewing-order.button.refund-partial': `Reembolso parcial`,
    'refunder.viewing-order.button.retry': `Reintentar`,
    'refunder.viewing-order.button.done': `Listo`,
    'refunder.viewing-order.button.back': `Atrás`,
    'refunder.viewing-order.refund-transaction.error': `No se pudo reembolsar la transacción. Por favor, intente de nuevo.`,
    'refunder.viewing-order.refund-transaction.success': `Transacción reembolsada exitosamente.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `La transacción se reembolsó exitosamente, pero no pudimos imprimir el recibo. Por favor, intente imprimir de nuevo.`,
    'refunder.viewing-order.transaction.total': `Total`,
    'refunder.viewing-order.transaction.refunded': `Reembolsado`,
    'refunder.viewing-order.error.title': `Error`,
    'refunder.viewing-order.error.message': `No se pudo cargar el pedido. Por favor, intente de nuevo.`,
    'refunder.viewing-order.error.button.retry': `Reintentar`,
    'refunder.viewing-order.error.button.back': `Atrás`,
    'refunder.partial-transaction-refund.error.amount-too-high': `El monto es demasiado alto.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `El monto es demasiado bajo.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `El monto no es válido.`,
    'refunder.partial-transaction-refund.error.amount-required': `El monto es obligatorio.`,
    'refunder.partial-transaction-refund.error': `Hubo un problema al procesar el reembolso. Por favor, intente de nuevo.`,
    'refunder.partial-transaction-refund.button.submit': `Enviar reembolso parcial`,
    'refunder.partial-transaction-refund.button.back': `Atrás`,
    'refunder.partial-transaction-refund.title': `Reembolso parcial de transacción`,
    'refunder.partial-transaction-refund.hint': `Por favor, ingrese el monto que desea reembolsar. El monto máximo es {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Monto`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.alcohol-requires-food.notice': ``,
    'checkout.cart.alcohol-requires-food.title': ``,
    'checkout.cart.alcohol-requires-food.description': ``,
    'checkout.cart.group-ordering.actions.change-recipient': `Editar destinatario`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Asignar artículo a`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Cancelar`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Agregar nuevo`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Reasignar`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `¿Para quién es este artículo?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Asignar a este invitado`,
    'checkout.cart.starbucks-stars': `Artículo de {{$1: amount}} ★`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'checkout.cart.upsize.title': ``,
    'checkout.cart.upsize.label': ``,
    'menu.nav.starbucks.menu': `Menú principal`,
    'menu.nav.starbucks.wayfinder': `Explorar el local`,
    'menu.disclaimer.title': ``,
    'menu.disclaimer.more': ``,
    'menu.secret-menu.access-code.title': `Ingresar código de acceso`,
    'menu.secret-menu.access-code.button.back': `Atrás`,
    'menu.secret-menu.access-code.button.submit': `Enviar`,
    'menu.secret-menu.access-code.error': `Código de acceso inválido`,
    'menu.secret-menu.access-code.success': `Código de acceso aceptado`,
    'menu.toast.added-to-cart': `Agregado al carrito`,
    'menu.toast.combo-savings': `¡Ahorro con combo!`,
    'menu.toast.discount-applied': `¡Descuento aplicado!`,
    'menu.mod-group-upsell.title': ``,
    'menu.mod-group-upsell.body': ``,
    'menu.mod-group-upsell.decline': ``,
    'menu.mod-group-upsell.confirmation.title': ``,
    'menu.mod-group-upsell.confirmation.body': ``,
    'menu.exit-verification.title': `Se requiere verificación del gerente`,
    'menu.exit-verification.description': `Se requiere un código de acceso de empleado para salir. Por favor, solicite ayuda a un miembro del equipo.`,
    'menu-item.starbucks-stars': `{{$1: amount}} ★`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Por favor, coloque su artículo en la báscula.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Pesa`,
    'menu-item.scale.price-per-unit': `{{$1: price}} por {{$2: unit}}`,
    'menu-item.scale.price': `Precio`,
    'menu-item.scale.instructions': `Use la balanza para pesar su artículo. Para reiniciar, presione el botón indicado en la balanza.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Pesando...`,
    'menu-item.scale.error-reading-weight': `Error al leer el peso. Por favor, intente de nuevo.`,
    'menu-item.scale.error-no-weight': `Por favor pese su artículo si desea agregarlo a su pedido.`,
    'menu-item.scale.no-scale': `No se detectó balanza. Por favor, comuníquese con un miembro del personal.`,
    'also-consider.title': `También le puede interesar...`,
    'also-consider.back-to-item': `Volver al artículo`,
    'also-consider.add-to-order': `Agregar al pedido`,
    'also-consider.skip-add-on': `Omitir complemento`,
    'menu-item.assorted.title': `Arme su surtido`,
    'menu-item.assorted.count': `{{$1: count}} de {{$2: total}} seleccionados`,
    'menu-item.row-size-mod.option.none': `Ninguno`,
    'menu-item.upsize.prompt.title': `¿Quieres un tamaño más grande?`,
    'menu-item.upsize.comparison.title': ``,
    'menu-item.upsize.comparison.accept': ``,
    'menu-item.upsize.comparison.speech': ``,
    'menu-item.upsize.comparison.price-difference': ``,
    'menu-item.upsize.prompt.accept': `Sí, quiero {{$1: size name}}`,
    'menu-item.upsize.prompt.decline': `No, gracias`,
    'menu-item.upsize.nudge': `Cámbialo a {{$1: size name}}`,
    'menu-item.upsize.selection-loss.title': ``,
    'menu-item.upsize.selection-loss.description': ``,
    'menu-item.upsize.selection-loss.confirm': ``,
    'menu-item.upsize.selection-loss.cancel': ``,
    'menu-item.high-sugar-warning.description': `Advertencia: Este ícono indica que el contenido de azúcares añadidos de este artículo es igual o superior al límite diario total recomendado de azúcares añadidos para una dieta de 2,000 calorías (50 g). Comer o beber grandes cantidades de azúcares añadidos con el tiempo puede aumentar el riesgo de diabetes tipo 2, aumento de peso y caries dental.`,
    'menu-item.high-sodium-warning.description': `Advertencia: Este ícono indica que el contenido de sodio (sal) de este artículo es superior al límite diario total recomendado (2,300 mg). Un alto consumo de sodio puede aumentar la presión arterial y el riesgo de enfermedades cardíacas y derrames cerebrales.`,
    'menu-item.group-ordering.items-for': `Pedido grupal - Artículos para:`,
    'menu-item.group-ordering.prompt.title': `¿Ordenando en grupo?`,
    'menu-item.group-ordering.prompt.description': `La opción de pedido grupal le preguntará a qué miembro de su grupo corresponde cada artículo. Toque "Sí" para activar el pedido grupal. Toque "No" si desea continuar con esta opción.`,
    'menu-item.group-ordering.prompt.button.accept': `Sí, pedido grupal`,
    'menu-item.group-ordering.prompt.button.decline': `No, gracias`,
    'menu-item.group-ordering.add-recipient': `Agregar nuevo`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Agregar nuevo destinatario`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Ingrese el nombre del destinatario`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Asignar al invitado`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Cancelar`,
    'menu-item.group-ordering.recipient-picker.title': `¿Para quién es?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Agregar nuevo`,
    'menu-item.nested-mod-groups.edit': `Editar`,
    'menu-item.nested-mod-groups.popup.done': `Listo`,
    'menu-item.nested-mod-groups.popup.cancel': `Cancelar`,
    'menu-item.nested-mod-groups.popup.back': `Atrás`,
    'menu-item.nested-mod-groups.popup.next': `Siguiente`,
    'checkout.cart.remove-item-verification.title': `Se requiere verificación del gerente`,
    'checkout.cart.remove-item-verification.description': `Se requiere un código de acceso de empleado para eliminar este artículo del carrito. Por favor, solicite ayuda a un miembro del equipo.`,
    'checkout.cart.confirm-remove-item.title': `¿Eliminar artículo?`,
    'checkout.cart.confirm-remove-item.description': `¿Está seguro de que desea eliminar {{$1: item name}} de su carrito?`,
    'checkout.cart.confirm-remove-item.cancel': `Cancelar`,
    'checkout.cart.confirm-remove-item.confirm': `Eliminar`,
    'checkout.cart.pre-checkout-recommendations.title': `Complete su pedido`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Continuar`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Atrás`,
    'checkout.cart.item-86d.title.items': `Algunos artículos ya no están disponibles`,
    'checkout.cart.item-86d.title.mods': `Algunas modificaciones ya no están disponibles`,
    'checkout.cart.item-86d.title.mixed': `Algunos artículos y modificaciones ya no están disponibles`,
    'checkout.cart.item-86d.description.items': `Los siguientes artículos se han eliminado de su carrito:`,
    'checkout.cart.item-86d.description.mods': `Las siguientes modificaciones se han eliminado de sus artículos:`,
    'checkout.cart.item-86d.description.mixed': `Lo siguiente ya no está disponible y se ha eliminado:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (en {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Editar`,
    'checkout.payment-options.tip.invalid-tip-amount': `Lo sentimos, no puede aplicar una propina mayor que el total del pedido. Por favor, ingrese un valor de propina menor que el subtotal del pedido menos los descuentos.`,
    'checkout.payment-options.name.title': `Hola, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Seleccione un método de tarjeta de regalo`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Tarjeta de regalo`,
    'checkout.payment-options.pay-with-cash-machine.label': `Toque para pagar con la máquina de efectivo`,
    'checkout.payment-options.pay-with-cash-machine.button': `Efectivo`,
    'checkout.payment-options.donation.or': `O`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Información del cargo por servicio`,
    'checkout.payment-options.credit-card.button.zero-balance': `Realizar pedido`,
    'checkout.payment-options.inline-loyalty.view-all': `Ver todas las recompensas`,
    'checkout.payment-options.inline-loyalty.apply': `Aplicar recompensas`,
    'checkout.payment-options.inline-loyalty.greeting': `¡Hola, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `Saldo de Estrellas: {{$1: stars}}★`,
    'checkout.payment-options.inline-loyalty.celebration.title': `¡Feliz cumpleaños!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `¡Feliz cumpleaños, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `¡Disfrute su regalo!`,
    'checkout.payment-options.inline-loyalty.error.title': `No se pudieron aplicar las recompensas`,
    'checkout.payment-options.inline-loyalty.error.message': `Hubo un error al aplicar sus recompensas. Por favor, intente de nuevo.`,
    'loyalty.starbucks.header.redeemable-stars': `Estrellas canjeables`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}★ vencen el {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Sus Estrellas no vencerán`,
    'loyalty.starbucks.progress.next-status-by-date': `Gane {{$1: stars}}★ antes del {{$2: date}} para alcanzar el nivel {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `Gane {{$1: stars}}★ para alcanzar el nivel {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Gane {{$1: stars}}★ antes del {{$2: date}} para extender su nivel {{$3: level}} por un año más`,
    'loyalty.starbucks.progress.maintain-status': `Gane {{$1: stars}}★ para extender su nivel {{$2: level}} por un año más`,
    'loyalty.starbucks.progress.extended': `Extendido por un año más`,
    'loyalty.starbucks.progress.annual-earned': `Ganadas este año`,
    'loyalty.starbucks.progress.status-target': `Nivel {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `para extender`,
    'loyalty.starbucks.birthday.title': `¡Feliz cumpleaños, {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `¡Feliz cumpleaños!`,
    'loyalty.starbucks.birthday.redeem': `¡Canjee su cupón de cumpleaños!`,
    'loyalty.starbucks.birthday.description': `Disfrute de su bebida o antojo favorito, cortesía nuestra. Canjéelo al pagar o infórmele a su barista al ordenar.`,
    'loyalty.starbucks.birthday.valid-until': `Válido hasta el {{$1: date}}`,
    'loyalty.starbucks.member-since': `Miembro desde {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Gracias por ser un miembro leal de Starbucks Rewards.`,
    'checkout.paying.error.card-not-accepted': ``,
    'checkout.paying.error.loyalty-payment': `Lo sentimos, no pudimos procesar su pago. Por favor, intente de nuevo.`,
    'checkout.paying.error.pos.print': `Continuar e imprimir recibo`,
    'checkout.paying.error.table-tracker.print': `Continuar e imprimir recibo`,
    'checkout.paying.error.table-tracker.title': `¡Ups! No pudimos obtener su localizador.`,
    'checkout.paying.error.table-tracker.instructions': `Su pedido se procesó, pero hubo un error al dispensar el localizador de mesa para rastrear su pedido. Continúe con el siguiente paso para recibir su recibo.`,
    'checkout.paying.error.title': `¡Ups!`,
    'checkout.paying.sending-table-tracker-request.title': `Dispensando localizador`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Por favor, espere mientras dispensamos su localizador de mesa.`,
    'checkout.paying.cash-machine.pinging.title': `Verificando la máquina de efectivo`,
    'checkout.paying.cash-machine.pinging.subtitle': `Por favor, espere mientras verificamos si la máquina de efectivo está disponible.`,
    'checkout.paying.cash-machine.awaiting.title': `Máquina de efectivo en uso`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Por favor, espere hasta que la máquina de efectivo esté disponible.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Cancelar`,
    'checkout.paying.cash-machine.receiving.title': `Máquina de efectivo lista`,
    'checkout.paying.cash-machine.receiving.subtitle': `Por favor, inserte su pago en la máquina de efectivo.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Cancelar`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Cancelar y reembolsar el pago`,
    'checkout.paying.cash-machine.receiving.partial-button': `Pagar el resto de otra manera`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} restante`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Por favor, tome todos los billetes y monedas de la máquina de efectivo.`,
    'checkout.paying.cash-machine.cancelling.title': `Cancelando el pago en la máquina de efectivo`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Por favor, tome todos los billetes y monedas de la máquina de efectivo.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Error al cancelar el pago en la máquina de efectivo`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `No se pudo cancelar su pago. Por favor, pida ayuda a un miembro del personal.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Continuar e imprimir recibo`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Cambio insuficiente`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `La máquina de efectivo no pudo darle cambio por su pago, así que hemos reembolsado su pago.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Intentar de nuevo`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Atrás`,
    'checkout.paying.cash-machine.error.message': `La máquina de efectivo no pudo procesar su pago. Por favor, intente de nuevo.`,
    'checkout.done.details.guest-name': `Nombre`,
    'checkout.done.details.table-number': `Número de mesa`,
    'checkout.done.details.tracker-number': `Número de rastreador`,
    'checkout.done.details.order-number': `Número de pedido`,
    'checkout.done.error.table-tracker.instructions': `Hubo un error al obtener su localizador. Su pedido se procesó exitosamente. Por favor, pida ayuda a un empleado.`,
    'checkout.done.qr-code.error': `Lo sentimos, no pudimos generar un código QR para su recibo.`,
    'printer-receipt.stored-value-remaining-balance': `Saldo restante de {{$1: label}}`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `La opción de comedor que seleccionó ya no está disponible. Su pedido se ha actualizado para usar "{{$1: dining option name}}".`,
    'order-reconciler.error.items-unavailable': `Algunos artículos de su pedido ya no están disponibles. Su pedido se ha actualizado para eliminar los artículos no disponibles. Se han eliminado los siguientes artículos: {{$1: item names}}`,
    'page-nav.order-history-item.title': `Sus pedidos`,
    'page-nav.order-history-item.cta': `Ver mis pedidos`,
    'print.error.phone-number-label': `Número de teléfono`,
    'print.error.guest-name-label': `Nombre`,
    'print.error.table-number-label': `Número de mesa`,
    'print.error.tracker-number-label': `Número de localizador`,
    'print.error.order-number-label': `Número de pedido`,
    'debug.untranslated-locale': `Agregar propina`,
};
//# sourceMappingURL=strings.es-us.js.map